import { createTheme } from '@mui/material/styles'

import { govioTheme } from '@/theme'

/**
 * Platform Console — identidad visual propia, inequívocamente distinta del
 * cliente GOVIA (azul marino + índigo): grafito neutro cálido, acento
 * ámbar (operación interna) y secundario turquesa, esquinas más rectas y
 * densidad de consola SaaS. Se anida vía <ThemeProvider> dentro de
 * AppShellSuperAdmin; nunca reemplaza el ThemeProvider raíz del cliente.
 */
export const platformSurfaces = {
  canvas: '#0E0F12',
  sidebar: '#131418',
  topbar: '#16171C',
  raised: '#1B1D22',
  border: 'rgba(245, 158, 11, 0.16)',
  accentStripe: 'linear-gradient(90deg, #F59E0B 0%, #FBBF24 55%, #2DD4BF 100%)',
}

export const superAdminTheme = createTheme(govioTheme, {
  palette: {
    primary: {
      main: '#F59E0B',
      light: '#FBBF24',
      dark: '#B45309',
      contrastText: '#1A1300',
    },
    secondary: {
      main: '#2DD4BF',
      light: '#5EEAD4',
      dark: '#0F9F8E',
      contrastText: '#03140F',
    },
    background: {
      default: platformSurfaces.canvas,
      paper: platformSurfaces.raised,
    },
    divider: 'rgba(214, 211, 209, 0.12)',
    text: {
      primary: '#ECEAE6',
      secondary: '#A8A29E',
      disabled: '#6B6560',
    },
  },
  shape: {
    borderRadius: 4,
  },
  typography: {
    fontFamily: govioTheme.typography.fontFamily,
  },
  components: {
    MuiPaper: {
      styleOverrides: { root: { backgroundImage: 'none' } },
    },
    MuiTableCell: {
      styleOverrides: {
        head: { fontWeight: 700, fontSize: '0.72rem', letterSpacing: '0.04em', textTransform: 'uppercase' },
      },
    },
    MuiTab: {
      styleOverrides: { root: { textTransform: 'none', fontWeight: 600, minHeight: 44 } },
    },
  },
})
